<template>
  <div class="EmptyStatePlaceholder empty-state-placeholder mx-1">
    <div>
      <div class="d-flex justify-content-center">
        <div class="svg-wrapper">
          <slot>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M5 3a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V5a2 2 0 00-2-2H5zm0 2h10v7h-2l-1 2H8l-1-2H5V5z" clip-rule="evenodd" />
            </svg>
          </slot>
        </div>
      </div>
      <h4 v-if="title">
        {{ title }}
      </h4>
      <p v-if="description">
        {{ description }}
      </p>

      <slot name="after"></slot>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: false,
    },
  },  
}

</script>

<style scoped>

.EmptyStatePlaceholder {
  text-align: center;
  max-width: 310px;
}

svg {
  width: 100%;
  height: 100%;
}

.svg-wrapper {
  width: 75px;
  color: rgb(200,200,200);
}

h4 {
  margin: 0;
  font-size: 1.125em;
}

h4, p {
  color: #464646;
}

h4 {
  color: #1c1c1c;
}

p {
  white-space: initial;
}

</style>
